import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { book } from './model/book';
import { Observable, BehaviorSubject } from 'rxjs';
import { customer } from './model/customer';

@Injectable({
  providedIn: 'root'
})
export class BookServiceService {

  constructor(private http: HttpClient) { }
  private loggedInCustomer = new BehaviorSubject<customer>(JSON.parse(sessionStorage.getItem("customer")));
  updatedCustomer = this.loggedInCustomer.asObservable();

  updatedCustomerDetails(customer: customer) {
      this.loggedInCustomer.next(customer);
  }
  getbook():Observable<book[]>{
    return this.http.get<book[]>("https://house-books1.herokuapp.com/book/books")
    
  }
}
